package gr.tech.GRAttestation.styles.admin

import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.style.CssStyle
import gr.tech.GRAttestation.styles.defaultText
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.px

val AdminSummaryBoxStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .minHeight(400.px)
            .maxHeight(400.px)
            .height(400.px)
    }
}

val AdminSummaryTitleStyle = CssStyle {
    base {
        Modifier
            .defaultText()
            .fontSize(1.5.cssRem)
            .fontWeight(FontWeight.Bold)
            .margin(topBottom = 8.px)
    }
}